/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import ErrorName from '../../../../core/error/error-name';

/**
 * Správce přenosů souborů po síti pro webovou platformu.
 * @implements {FileTransferManager}
 * @memberof AdapterWeb
 */
class FileTransferManager {
  /** @inheritdoc */
  download(path, input, init) {
    return new Promise(() => {
      const error = new Error('Unable to download any file.');
      error.name = ErrorName.NotSupportedError;
      throw error;
    });
  }
}

export default FileTransferManager;
